import { fire } from 'delegated-events';
import helpers from './helpers.js';
/*
=================================================================
VIDEO PLAYER
=================================================================
*/
export default (function () {
  return {
    init() {
      const vids = document.querySelectorAll('.js-inline-video');
      const vidsWithTitle = document.querySelectorAll('.video-and-title');
      let isAPIReady = false;
      const isChina =
        document.querySelectorAll('.js-inline-video[data-qq-id]').length > 0;
      if (!vids.length) return;

      helpers.addClass(vids, 'is-waiting');
      helpers.setAttributes(vids, {
        tabindex: 0,
        role: 'button',
      });

      // Load YouTube Frame API
      (function () {
        // Closure, to not leak to the scope
        const s = document.createElement('script');
        s.src = '//www.youtube.com/iframe_api'; /* Load Player API */
        const before = document.getElementsByTagName('script')[0];
        before.parentNode.insertBefore(s, before);
      })();

      let players = 0;

      const chinaVidSetup = function () {
        const videos = document.querySelectorAll(
          '.js-inline-video.is-waiting[data-qq-id]'
        );
        helpers.forEach(videos, (i, el) => {
          el.addEventListener('keyup', (e) => {
            if (e.keyCode === 13) {
              fire(e.target, 'click');
            }
          });
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const vid = e.currentTarget;
            const qqid = vid.getAttribute('data-qq-id');

            // play loading animation
            helpers.removeClass(vid, 'is-waiting');
            helpers.addClass(vid, 'is-loading');
            vid.removeAttribute('role');
            vid.setAttribute('tabindex', -1);

            vid
              .querySelector('.inline-video__iframe')
              .insertAdjacentHTML(
                'afterbegin',
                `<iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=${qqid}&amp;auto=0" allowFullScreen="true"></iframe>`
              );

            const poster = vid.querySelector('.inline-video__poster');
            helpers.addClass(poster, 'u-hide');
            helpers.removeClass(vid, 'is-loading');
            helpers.addClass(vid, 'is-loaded');
          });
        });
      };

      if (isChina) {
        chinaVidSetup();
      }

      const e3Vidsetup = function () {
        const videos = document.querySelectorAll(
          '.js-inline-video.is-waiting[data-yt-id]'
        );

        helpers.forEach(videos, (i, el) => {
          el.addEventListener('keyup', (e) => {
            if (e.keyCode === 13) {
              fire(e.target, 'click');
            }
          });

          el.addEventListener('click', (e) => {
            e.preventDefault();
            const vid = e.currentTarget;
            const ytid = vid.getAttribute('data-yt-id');
            let oPlayer;

            // play loading animation
            helpers.removeClass(vid, 'is-waiting');
            helpers.addClass(vid, 'is-loading');
            vid.removeAttribute('role');
            vid.setAttribute('tabindex', -1);

            vid
              .querySelector('.inline-video__iframe')
              .insertAdjacentHTML(
                'afterbegin',
                `<div id="inline-video-${players}"></div>`
              );

            // 1. bind events
            function bindYtEvents() {
              vid.addEventListener('ivp-play', (ev) => {
                oPlayer.playVideo();
              });
              vid.addEventListener('ivp-pause', (ev) => {
                oPlayer.pauseVideo();
              });
              vid.addEventListener('ivp-stop', (ev) => {
                oPlayer.stopVideo();
              });
              vid.addEventListener('ivp-mute', (ev) => {
                oPlayer.muteVideo();
              });
              vid.addEventListener('ivp-unmute', (ev) => {
                oPlayer.unmuteVideo();
              });
              helpers.triggerEvent(vid, 'ivp-loaded');

              // 3. hide splash screen
              const poster = vid.querySelector('.inline-video__poster');
              helpers.addClass(poster, 'u-hide');
              helpers.removeClass(vid, 'is-loading');
              helpers.addClass(vid, 'is-loaded');

              const vidTitle = vid.closest('.video-and-title');
              if (vidTitle != null) {
                helpers.addClass(vidTitle, 'is-playing');
              }

              vid.querySelector('iframe').focus();
            }

            // a. create the player
            oPlayer = new YT.Player(`inline-video-${players}`, {
              videoId: ytid,
              playerVars: {
                controls: 1,
                showinfo: 0,
                modestbranding: 1,
                wmode: 'transparent',
                rel: 0,
                autoplay: true,
                html5: 1,
                loop: false,
                width: 980,
              },
              events: {
                onReady: bindYtEvents,
              },
            });

            players += 1;
          });
        });
      };

      // Create our custom event

      window.addEventListener('e3YouTubeAPIReady', () => {
        e3Vidsetup();
      });

      const event = document.createEvent('Event');

      event.initEvent('e3YouTubeAPIReady', true, true);

      // Finaly, make sure we trigger that event once the API is ready
      if (typeof window.onYouTubeIframeAPIReady === 'undefined') {
        window.onYouTubeIframeAPIReady = function () {
          window.e3YouTubeAPIReady = true;

          isAPIReady = true;

          window.dispatchEvent(event);
        };
      } else {
        const oldOnYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady;

        window.onYouTubeIframeAPIReady = function () {
          oldOnYouTubeIframeAPIReady();

          window.e3YouTubeAPIReady = true;

          isAPIReady = true;

          window.dispatchEvent(event);
        };
      }
    },
  };
})();
